export default __webpack_public_path__ + "static/media/ESTP.7e45568d.svg";